import { render, staticRenderFns } from "./SoccerhowRealTimeNews.vue?vue&type=template&id=29a57f16&scoped=true&"
import script from "./SoccerhowRealTimeNews.vue?vue&type=script&lang=js&"
export * from "./SoccerhowRealTimeNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a57f16",
  null
  
)

export default component.exports